import { useEffect, useState } from 'react';

/**
 * A/B Variant Hook.
 * Reads `?variant=A|B` from URL first, then localStorage.
 * If neither exists, assigns 50/50 split and persists.
 * Emits a console log (no GA4 wiring by user request).
 */
export function useABVariant(experimentKey = 'trust_ui_v1') {
  const [variant, setVariant] = useState('A');

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const forced = params.get('variant');
      if (forced === 'A' || forced === 'B') {
        setVariant(forced);
        try { localStorage.setItem(`ab_${experimentKey}`, forced); } catch (e) { /* noop */ }
        return;
      }
      const stored = localStorage.getItem(`ab_${experimentKey}`);
      if (stored === 'A' || stored === 'B') {
        setVariant(stored);
        return;
      }
      const assigned = Math.random() < 0.5 ? 'A' : 'B';
      try { localStorage.setItem(`ab_${experimentKey}`, assigned); } catch (e) { /* noop */ }
      setVariant(assigned);
    } catch (e) {
      setVariant('A');
    }
  }, [experimentKey]);

  const track = (event, data = {}) => {
    console.log('trust_event', { experiment: experimentKey, variant, event, ...data });
  };

  return { variant, track, isB: variant === 'B' };
}
